import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      activeTab: 'publicView/getActiveTab',
      resourceTypes: 'publicView/resourceTypes',
      publicViewLabel: 'publicView/getLabel',
      selected: 'publicView/getSelected',
      selectedTree: 'tree/selected'
    }),
    activeResourceType () {
      return this.resourceTypes[this.activeTab].type
    },
    organisationalUnitName () {
      if (this.selectedTree && !this.selectedTree.name) {
        return this.publicViewLabel
      } else {
        return this.selectedTree.name
      }
    },
    toCurrentRoute () {
      let to = {
        name: 'public',
        params: {
          type: this.selected.type || 'ou',
          id: this.selected.id || 1,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      }

      if (this.isCompactView) {
        to.query = {
          compact: true
        }
      }

      return to
    }
  },
  methods: {
    loadAsyncData () {
      this.$store.dispatch('publicView/loadAsyncData', this.activeResourceType)
    },
    setFirstPage () {
      this.$store.dispatch('publicView/setConfig', {
        resourceType: this.activeResourceType,
        property: 'page',
        value: 1
      })
    },
    toPublicRoute (type = 'ou', id = 1, resourceType = 'forschungsprojekt') {
      let to = {
        name: 'public',
        params: {
          type,
          id,
          resourceType
        }
      }

      if (this.isCompactView) {
        to.query = {
          compact: true
        }
      }

      return to
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/PublicViewHelper.js